import script from "./ProductModify.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductModify.vue?vue&type=script&setup=true&lang=js"

import "./ProductModify.vue?vue&type=style&index=0&id=b9227fb0&lang=scss"

const __exports__ = script;

export default __exports__